import { InjectionToken } from '@angular/core';

import { Organization } from '@iss/libs/graphql';

export const SUPPLIER_ID = new InjectionToken<Organization['id']>('SUPPLIER_ID');
